import { UI_THEME } from '../../ui/theme';
import { FIELD_CLASS } from '../../components/ui/fieldStyles';

export const isSaas = UI_THEME === 'saas';

export const surfaceClass = 'border-slate-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-900/80';
export const subtleSurfaceClass = 'border-slate-200 bg-slate-50 dark:border-slate-700 dark:bg-slate-800/70';
export const accentTextClass = isSaas ? 'text-teal-700 dark:text-teal-300' : 'text-blue-700 dark:text-blue-300';
export const bodyTextClass = 'text-slate-600 dark:text-slate-300';
export const labelTextClass = 'text-slate-500 dark:text-slate-400';
export const strongTextClass = 'text-slate-900 dark:text-slate-100';
export const inputClass = FIELD_CLASS;
export const primaryButtonClass = isSaas
  ? 'bg-teal-600 text-white hover:bg-teal-700 dark:bg-teal-500 dark:hover:bg-teal-400'
  : 'bg-blue-700 text-white hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-500';
export const secondaryButtonClass =
  'border border-slate-300 bg-white text-slate-700 hover:bg-slate-50 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800';
export const dangerTextButtonClass = 'text-sm font-semibold text-red-600 dark:text-red-300';

export const formatCurrency = (value?: number | null) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);

export const formatDate = (value?: string | null) => {
  if (!value) return '-';
  const date = new Date(value.length === 10 ? `${value}T00:00:00` : value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString('pt-BR');
};

/** "2026-08" -> "agosto de 2026" */
export const monthLabel = (value?: string | null) => {
  if (!value || !/^\d{4}-\d{2}$/.test(value)) return value || '-';
  const [year, month] = value.split('-');
  const date = new Date(Number(year), Number(month) - 1, 1);
  return date.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
};

/** Rótulo de exibição de uma PC: "PC única" ou "PC 2 (agosto de 2026)". */
export const pcLabel = (pc: { tipo: 'UNICA' | 'PARCIAL'; numero: number; mes?: string }) =>
  pc.tipo === 'UNICA' ? 'PC única' : `PC ${pc.numero} (${monthLabel(pc.mes)})`;

/** Mascara um input de moeda enquanto o usuário digita (base em centavos), mesmo padrão de ExecucaoFinanceiraPanel. */
export const formatCurrencyInput = (value: string) => {
  const digits = value.replace(/\D/g, '');
  if (!digits) return '';
  return (Number(digits) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

/** Extrai o valor numérico de um input de moeda mascarado. */
export const parseCurrencyInput = (value: string): number => {
  const digits = value.replace(/\D/g, '');
  return digits ? Number(digits) / 100 : 0;
};

/** Rótulo da fonte declarada no pagamento da etapa (1 = Prefeitura, 2 = recurso próprio). */
export const fonteRecursoLabel = (fonte?: string | null) =>
  fonte === '1' ? 'Prefeitura' : fonte === '2' ? 'Recurso próprio' : 'Fonte não informada';

export type SectionProps = {
  pcId: string;
  podeEditar: boolean;
  /** Avisa a pagina que algo mudou: flags e pendencias de envio da PC vem do servidor e precisam ser relidas. */
  onAlterado?: () => void;
};
